import z from "zod";
import {
  BookkeepingAccountIdScheme,
  ModifierIdScheme,
  ProductGroupIdScheme,
} from "./ids";
import { MoneyScheme } from "./money";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const ModifierDBScheme = z.object({
  id: ModifierIdScheme,
  name: z.string(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  price: MoneyScheme.nullable(),
  productGroupId: ProductGroupIdScheme.nullable(),
  VAT: z.number().nullable(),
  bookkeepingAccountId: BookkeepingAccountIdScheme.nullable(),
  internal: z.boolean().optional(),
  maxQuantity: z.number().int().positive().nullable().optional(),
  slots: z.number().int().positive().nullable().optional(),

  takeawayPrice: MoneyScheme.nullable().optional(),
  takeawayVAT: z.number().nullable().optional(),
  takeawayBookkeepingAccountId:
    BookkeepingAccountIdScheme.nullable().optional(),
  origin: z.enum(CatalogOrigin).optional(),
});

export const RestGetModifier = ModifierDBScheme;

export const RestCreateModifier = ModifierDBScheme.omit({
  id: true,
  updatedAt: true,
  createdAt: true,
});

export const RestUpdateModifier = ModifierDBScheme.omit({
  id: true,
  updatedAt: true,
  createdAt: true,
}).partial();

export type DBModifier = z.infer<typeof ModifierDBScheme>;
export type RestModifier = z.infer<typeof RestGetModifier>;
export type RestCreateModifier = z.infer<typeof RestCreateModifier>;
export type RestUpdateModifier = z.infer<typeof RestUpdateModifier>;
